import Button from "@src/components/Button"
import { Dialog } from "@src/components/Dialog"

export type PayFromMode = "main" | "confidential"

export function PayFromModal({
  open,
  currentMode,
  onSelect,
  onCancel,
}: {
  open: boolean
  currentMode: PayFromMode
  onSelect: (mode: PayFromMode) => void
  onCancel: () => void
}) {
  return (
    <Dialog open={open} onClose={onCancel}>
      <p className="text-balance font-semibold text-gray-900 text-xl/6 tracking-tight dark:text-white">
        Pay from your Main or Confidential balance?
      </p>
      <p className="mt-2 font-medium text-base/5 text-gray-500 dark:text-gray-400">
        Both balances can fund this payment. Which would you like to use?
      </p>

      <div className="mt-5 flex flex-col gap-1.5">
        <Button
          type="button"
          variant={currentMode === "main" ? "primary" : "secondary"}
          size="xl"
          onClick={() => onSelect("main")}
          fullWidth
        >
          Pay from Main
        </Button>
        <Button
          type="button"
          variant={currentMode === "confidential" ? "primary" : "secondary"}
          size="xl"
          onClick={() => onSelect("confidential")}
          fullWidth
        >
          Pay from Confidential
        </Button>
      </div>
    </Dialog>
  )
}
